module.exports = __webpack_public_path__ + "static/img/6.d4548e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/6.png
// module id = adFc
// module chunks = 0